import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable, Subscription, finalize } from 'rxjs';
import { CoachMarkService } from 'src/app/account/core/services/coach-mark.service';

@Component({
  selector: 'app-coach-marks-reset-modal',
  templateUrl: './coach-marks-reset-modal.component.html',
  styleUrls: ['./coach-marks-reset-modal.component.scss']
})
export class CoachMarksResetModalComponent {

  resetingSubject: BehaviorSubject<boolean>;
  reseting$: Observable<boolean>;

  unsubscribe: Subscription[] = [];

  constructor(
    public modal: NgbActiveModal,
    private readonly coachMarksService: CoachMarkService
  ) {
    this.resetingSubject = new BehaviorSubject<boolean>(false);
    this.reseting$ = this.resetingSubject.asObservable();
  }

  reset() {
    this.resetingSubject.next(true);

    const resetCoachMarksSubscription = this.coachMarksService.resetCoachMarks().pipe(
      finalize(() => this.resetingSubject.next(false)),
    ).subscribe({
      next: () => {
        this.close();
      },
      error: (error: any) => {
        this.modal.dismiss(error);

        throw error;
      },
    });

    this.unsubscribe.push(resetCoachMarksSubscription);
  }

  private close() {
    this.modal.close();
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

}
